if (!customElements.get('manufacturer-links')) {
  class ManufacturerLinks extends HTMLElement {
    static requests = new Map();

    static parse(value) {
      const entries = new Map();
      value.split('|').filter(Boolean).forEach((entry) => {
        const separator = entry.indexOf('=');
        if (separator > 0) entries.set(entry.slice(0, separator), entry.slice(separator + 1));
      });
      return entries;
    }

    connectedCallback() {
      this.scope = this.closest('.shopify-section');
      if (!this.scope) return;
      this.links = ManufacturerLinks.parse(this.dataset.collections || '');
      this.updateLinks();
      this.observer = new MutationObserver(() => this.updateLinks());
      this.observer.observe(this.scope, { childList: true, subtree: true });
      if (this.links.has('__next') || Number(this.links.get('__page')) > 1) {
        this.loadAll().then((links) => {
          this.links = links;
          this.updateLinks();
        }).catch((error) => console.warn('Manufacturer collection links could not be loaded.', error));
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    updateLinks() {
      this.scope.querySelectorAll('a[data-manufacturer-id]').forEach((link) => {
        const url = this.links.get(link.dataset.manufacturerId);
        if (url) link.setAttribute('href', url);
      });
    }

    loadAll() {
      const source = this.dataset.source;
      if (!ManufacturerLinks.requests.has(source)) {
        ManufacturerLinks.requests.set(source, (async () => {
          const onFirstPage = Number(this.links.get('__page')) === 1;
          const links = onFirstPage ? new Map(this.links) : new Map();
          let next = new URL(onFirstPage ? this.links.get('__next') : source, window.location.origin);
          next.searchParams.set('section_id', 'manufacturer-collection-links');
          while (next) {
            const response = await fetch(next, { credentials: 'same-origin' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            const map = document.querySelector('[data-collection-map]');
            if (!map) throw new Error('Collection link data missing');
            const page = ManufacturerLinks.parse(map.dataset.collectionMap);
            page.forEach((url, id) => links.set(id, url));
            const following = page.get('__next');
            next = following ? new URL(following, next) : null;
            if (next) next.searchParams.set('section_id', 'manufacturer-collection-links');
          }
          return links;
        })());
      }
      return ManufacturerLinks.requests.get(source);
    }
  }
  customElements.define('manufacturer-links', ManufacturerLinks);
}
